import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import modules from "./modules";
import pusher from "./plugins/pusher";

const initialState = () => ({
    error: "",
    loading: 0,
});

export default new Vuex.Store({
    modules,
    state: initialState(),
    plugins: [pusher()],
    mutations: {
        RESET: (state) => {
            const newState = initialState();
            Object.keys(newState).forEach((key) => {
                state[key] = newState[key];
            });
        },
        SET_LOADING: (state, payload) => {
            state.loading = payload ? state.loading + 1 : state.loading - 1;
        },
        SET_ERROR: (state, payload) => {
            state.error = payload;
        },
    },
    getters: {
        loading: (state) => (state.loading > 0 ? true : false),
        error: (state) => state.error,
    },
    actions: {
        reset({ commit }) {
            commit("RESET");
            // resets state of all the modules
            Object.keys(modules).forEach((moduleName) => {
                commit(`${moduleName}/RESET`);
            });
        },
        error({ commit }, message) {
            commit("SET_LOADING", false);
            commit("SET_ERROR", message);
            // Adding setError as an action in a module allows the error to propogate
            Object.keys(modules).forEach((moduleName) => {
                if (this._actions[`${moduleName}/error`]) {
                    this.dispatch(`${moduleName}/error`, true);
                }
            });
        },
    },
});
